export default __webpack_public_path__ + "static/Winter-2021-header-314bee9400c06931697809886c98f9e5.jpg";